// extracted by mini-css-extract-plugin
export default {"wellSelect":"wellSelect-sYAax","trigger":"trigger-rmI6u","popover":"popover-JTZjX","labwareSelect":"labwareSelect-eOUhx"};